'use client';

import { useState, useEffect } from 'react';
import CTAButton from '@/components/common/CTAButton';
import { useLanguage } from '@/contexts/LanguageContext';

const SavingsCalculator = () => {
  const { t } = useLanguage();
  const [savingsAmount, setSavingsAmount] = useState(10000);
  const [years, setYears] = useState(10);
  const [result, setResult] = useState<number | null>(null);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const calculateReturn = () => {
    const averageReturn = 0.08;
    const futureValue = savingsAmount * Math.pow(1 + averageReturn, years);
    setResult(futureValue);
  };

  const formatCurrency = (value: number) => {
    return value.toLocaleString('de-DE');
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-8">
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-primary mb-3">
        {t('whyGoldSilver.calculator.title')}
      </h2>
      <p className="font-body text-base text-muted-foreground mb-8">
        {t('whyGoldSilver.calculator.subtitle')}
      </p>
      <div className="space-y-6">
        {/* Savings Amount */}
        <div>
          <label className="block font-body text-sm font-medium text-foreground mb-2">
            {t('whyGoldSilver.calculator.investment')}: €{isClient ? formatCurrency(savingsAmount) : '10.000'}
          </label>
          <input
            type="range"
            min="1000"
            max="100000"
            step="1000"
            value={savingsAmount}
            onChange={(e) => setSavingsAmount(Number(e?.target?.value))}
            className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer accent-accent"
          />
        </div>

        {/* Savings Period */}
        <div>
          <label className="block font-body text-sm font-medium text-foreground mb-2">
            {t('whyGoldSilver.calculator.period')}: {years} {t('whyGoldSilver.calculator.years')}
          </label>
          <input
            type="range"
            min="1"
            max="30"
            step="1"
            value={years}
            onChange={(e) => setYears(Number(e?.target?.value))}
            className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer accent-accent"
          />
        </div>

        {/* Calculate Button */}
        <CTAButton 
          href="#"
          variant="primary"
          className="w-full"
          onClick={(e) => {
            e?.preventDefault();
            calculateReturn();
          }}
        >
          {t('whyGoldSilver.calculator.calculate')}
        </CTAButton>

        {/* Result */}
        {result !== null && (
          <div className="bg-accent/10 border-2 border-accent/20 rounded-lg p-6 text-center">
            <p className="font-body text-sm text-muted-foreground mb-2">
              {t('whyGoldSilver.calculator.result')}
            </p>
            <p className="font-heading text-3xl font-bold text-accent">
              €{formatCurrency(Math.round(result))}
            </p>
          </div>
        )}

        {/* Disclaimer */}
        <p className="text-xs text-muted-foreground text-center">
          {t('whyGoldSilver.calculator.disclaimer')}
        </p>
      </div>
    </div>
  );
};

export default SavingsCalculator;